import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';
import { Link } from 'react-router-dom';

import DangerousHTML from 'Components/Utility/DangerousHTML';
import VrIcons from 'Components/Utility/VrIcons';

import 'Components/VR/VrSupport.scss';

const VrSupport = ({ vr, requirements }) => {
  if (isEmpty(vr) || (
    !vr.vr_required &&
    !vr.htc_vive &&
    !vr.oculus_rift &&
    !vr.oculus_meta_quest &&
    !vr.oculus_meta_quest_two &&
    !vr.oculus_meta_quest_three &&
    !vr.valve_index &&
    !vr.windows_mixed_reality &&
    !vr.tracked_motion_controllers &&
    !vr.seated &&
    !vr.standing &&
    !vr.room_scale &&
    !vr.gamepad &&
    !vr.keyboard_mouse
  )) {
    return false;
  }

  return (
    <React.Fragment>
      <article className="vr-support">
        <h4>
          <FormattedMessage id="bundle.vrsupport.title.support" defaultMessage="VR Support" />
        </h4>
        <div className="vr-support-content">
          {(
            vr.valve_index ||
            vr.htc_vive ||
            vr.oculus_rift ||
            vr.oculus_meta_quest ||
            vr.oculus_meta_quest_two ||
            vr.oculus_meta_quest_three ||
            vr.windows_mixed_reality
          ) &&
            <div className="vr-segment">
              <div className="support-area-title">
                <FormattedMessage id="bundle.vrsupport.label.headsets" defaultMessage="Headsets" />
              </div>

              <div className="vr-items-container">
                {vr.valve_index &&
                  <div className="vr-item valve-index">
                    <div className="vr-item-icon">
                      <VrIcons vrFeature="valve_index" />
                    </div>
                    <div className="vr-item-title">
                      <Link to="/vr-games/valve-index">
                        Valve Index
                      </Link>
                    </div>
                  </div>
                }
                {vr.htc_vive &&
                  <div className="vr-item htc-vive">
                    <div className="vr-item-icon">
                      <VrIcons vrFeature="htc_vive" />
                    </div>
                    <div className="vr-item-title">
                      <Link to="/vr-games/htc-vive">HTC Vive</Link>
                    </div>
                  </div>
                }
                {vr.oculus_rift &&
                  <div className="vr-item oculus-rift">
                    <div className="vr-item-icon">
                      <VrIcons vrFeature="oculus_rift" />
                    </div>
                    <div className="vr-item-title">
                      <Link to="/vr-games/oculus-rift">Oculus Rift</Link>
                    </div>
                  </div>
                }
                {vr.oculus_meta_quest &&
                  <div className="vr-item oculus-meta-quest">
                    <div className="vr-item-icon">
                      <VrIcons vrFeature="oculus_meta_quest" />
                    </div>
                    <div className="vr-item-title">
                      <Link to="/vr-games/oculus-meta-quest">Meta Quest</Link>
                    </div>
                  </div>
                }
                {vr.oculus_meta_quest_two &&
                  <div className="vr-item oculus-meta-quest">
                    <div className="vr-item-icon">
                      <VrIcons vrFeature="oculus_meta_quest_two" />
                    </div>
                    <div className="vr-item-title">
                      <Link to="/vr-games/oculus-meta-quest-two">Meta Quest 2</Link>
                    </div>
                  </div>
                }
                {vr.oculus_meta_quest_three &&
                  <div className="vr-item oculus-meta-quest">
                    <div className="vr-item-icon">
                      <VrIcons vrFeature="oculus_meta_quest_three" />
                    </div>
                    <div className="vr-item-title">
                      <Link to="/vr-games/oculus-meta-quest-three">Meta Quest 3</Link>
                    </div>
                  </div>
                }
                {vr.windows_mixed_reality &&
                  <div className="vr-item windows-mixed-reality">
                    <div className="vr-item-icon">
                      <VrIcons vrFeature="windows_mixed_reality" />
                    </div>
                    <div className="vr-item-title">
                      <Link to="/vr-games/windows-mixed-reality">Windows Mixed Reality</Link>
                    </div>
                  </div>
                }
              </div>
            </div>
          }


          {(vr.tracked_motion_controllers || vr.gamepad || vr.keyboard_mouse) &&
            <div className="vr-segment">
              <div className="support-area-title">
                <FormattedMessage id="bundle.vrsupport.label.input" defaultMessage="Input" />
              </div>
              <div className="vr-items-container">
                {vr.tracked_motion_controllers &&
                  <div className="vr-item motion-controllers">
                    <div className="vr-item-icon">
                      <VrIcons vrFeature="tracked_motion_controllers" />
                    </div>
                    <div className="vr-item-title">
                      <Link to="/vr-games/tracked-motion-controllers">
                        <FormattedMessage id="bundle.vrsupport.label.tracked-motion" defaultMessage="Tracked Motion Controllers" />
                      </Link>
                    </div>
                  </div>
                }
                {vr.gamepad &&
                  <div className="vr-item gamepad">
                    <div className="vr-item-icon">
                      <VrIcons vrFeature="gamepad" />
                    </div>
                    <div className="vr-item-title">
                      <Link to="/vr-games/gamepad">
                        <FormattedMessage id="bundle.vrsupport.label.gamepad" defaultMessage="Gamepad" />
                      </Link>
                    </div>
                  </div>
                }
                {vr.keyboard_mouse &&
                  <div className="vr-item keyboard-mouse">
                    <div className="vr-item-icon">
                      <VrIcons vrFeature="keyboard_mouse" />
                    </div>
                    <div className="vr-item-title">
                      <Link to="/vr-games/keyboard-mouse">
                        <FormattedMessage id="bundle.vrsupport.label.keyboard-mouse" defaultMessage="Keyboard / Mouse" />
                      </Link>
                    </div>
                  </div>
                }
              </div>
            </div>
          }

          {(vr.seated || vr.standing || vr.room_scale) &&
            <div className="vr-segment">
              <div className="support-area-title">
                <FormattedMessage id="bundle.vrsupport.label.play-area" defaultMessage="Play Area" />
              </div>
              <div className="vr-items-container">
                {vr.seated &&
                  <div className="vr-item seated">
                    <div className="vr-item-icon">
                      <VrIcons vrFeature="seated" />
                    </div>
                    <div className="vr-item-title">
                      <Link to="/vr-games/seated">
                        <FormattedMessage id="bundle.vrsupport.label.seated" defaultMessage="Seated" />
                      </Link>
                    </div>
                  </div>
                }
                {vr.standing &&
                  <div className="vr-item standing">
                    <div className="vr-item-icon">
                      <VrIcons vrFeature="standing" />
                    </div>
                    <div className="vr-item-title">
                      <Link to="/vr-games/standing">
                        <FormattedMessage id="bundle.vrsupport.label.standing" defaultMessage="Standing" />
                      </Link>
                    </div>
                  </div>
                }
                {vr.room_scale &&
                  <div className="vr-item room-scale">
                    <div className="vr-item-icon">
                      <VrIcons vrFeature="room_scale" />
                    </div>
                    <div className="vr-item-title">
                      <Link to="/vr-games/room-scale">
                        <FormattedMessage id="bundle.vrsupport.label.room-scale" defaultMessage="Room-Scale" />
                      </Link>
                    </div>
                  </div>
                }
              </div>
            </div>
          }

          <div className="vr-segment">
            <div className="support-area-title">
              <FormattedMessage id="bundle.vrsupport.label.required-optional" defaultMessage="Required or Optional" />
            </div>
            <div className="vr-items-container">
              {vr.vr_required &&
                <div className="vr-item vr-required">
                  <div className="vr-item-icon">
                    <VrIcons vrFeature="vr_required" />
                  </div>
                  <div className="vr-item-title">
                    <FormattedMessage id="bundle.vrsupport.label.vr-required" defaultMessage="VR Required" />
                  </div>
                </div>
              }
              {!vr.vr_required &&
                <div className="vr-item vr-required">
                  <div className="vr-item-icon">
                    <VrIcons vrFeature="vr_required" />
                  </div>
                  <div className="vr-item-title">
                    <FormattedMessage id="bundle.vrsupport.label.vr-optional" defaultMessage="VR Optional" />
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </article>

      {requirements &&
        <article className="mt-3 mt-md-5">
          <h4>
            <FormattedMessage id="bundle.vrsupport.title.requirements" defaultMessage="VR Requirements" />
          </h4>
          <DangerousHTML html={requirements} />
        </article>
      }
    </React.Fragment>
  );
};

VrSupport.propTypes = {
  vr: PropTypes.shape({}),
  requirements: PropTypes.string,
};

VrSupport.defaultProps = {
  vr: {},
  requirements: '',
};

export default VrSupport;
